import { useEffect } from 'react'
import {
  addCommonFormErrors,
  deleteCommonFormErrors,
} from '@/containers/SubscriptionFormPage/SubscriptionFormConfigurationSlice'
import { useDispatch } from 'react-redux'
import useGasMeter from '@/containers/SubscriptionFormPageNew/Components/GasMeter/useGasMeter'

const useGasMeterListener = () => {
  const dispatch = useDispatch()
  const { pceNo, treatMeterDataInformation, gasMeterUpdate } = useGasMeter({ type: 'client' })

  useEffect(() => {
    if (!pceNo) {
      return
    }
    window.Echo.channel(`pce.${pceNo}`).listen('.pce.response', e => {
      if (e.status === 'pending') {
        gasMeterUpdate({
          pceEligibilityPending: true,
        })
      }

      if (e.status === 'error') {
        gasMeterUpdate({
          pceEligibilityPending: false,
          pceEligibilityLoading: false,
        })
        dispatch(addCommonFormErrors({ meter_id_gas: e.response.exception }))
      }

      if (e.response.gas?.deliveryPoint?.pointOfDelivery && e.response.gas.deliveryPoint.pointOfDelivery !== pceNo) {
        return
      }

      if (e.status === 'success') {
        gasMeterUpdate({
          pceEligibilityPending: false,
          pceEligibilityLoading: false,
        })
        dispatch(deleteCommonFormErrors('meter_id_gas'))
        const pceInformation = e.response

        if (pceInformation.exception) {
          dispatch(addCommonFormErrors({ meter_id_gas: pceInformation.exception }))
          return
        }
        if (pceInformation.error && !Array.isArray(pceInformation.error)) {
          if (
            typeof pceInformation.error.errors?.authorizations !== 'undefined' &&
            Array.isArray(pceInformation.error.errors.authorizations)
          ) {
            dispatch(addCommonFormErrors({ meter_id_gas: pceInformation.error.errors.authorizations[0] }))
            return
          }
          const pceErrorMsg = typeof pceInformation.error === 'string' ? pceInformation.error : pceInformation.error?.message ?? 'Erreur PCE'
          dispatch(addCommonFormErrors({ meter_id_gas: pceErrorMsg }))
          return
        }
        treatMeterDataInformation(pceInformation)
      }
    })
    return () => {
      window.Echo.leaveChannel(`pce.${pceNo}`)
    }
  }, [pceNo])
}

export default useGasMeterListener
